import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token = (sessionStorage.getItem('token'))?sessionStorage.getItem('token').slice(0, -4):'';
    if(!token)
      token = 'null';
    let urlss= request.url;
    //console.log(token);
    return next.handle(request = request.clone({
        setHeaders:{
          authorization: token,
        },
        headers: request.headers.append('authorization', token),
    }));
  }
}
